import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import VisaAPIconfig from "../../Common/Configurations/VisaAPIConfig";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getUserId } from "./userHelper";
import LayoutHeader from "../../Common/Layout/Header";

export default function VisaInvoice() {
  const { visaRequestId } = useParams();
  const [visaRequest, setVisaRequest] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  useEffect(() => {
    axios
      .get(
        VisaAPIconfig.APIACTIVATEURL +
          VisaAPIconfig.GETVISAREQUESTBYID +
          "/" +
          visaRequestId,
        { ...headerconfig }
      )
      .then((response) => {
        setVisaRequest(response.data.data);

        const userId = response.data.data.userId;
        if (userId) {
          axios
            .get(
              VisaAPIconfig.APIACTIVATEURL +
                VisaAPIconfig.GETUSER +
                "/" +
                getUserId(),
              {
                ...headerconfig,
              }
            )
            .then((res) => {
              if (res.data.statusCode === 200) {
                setProfile(res.data.data);
              }
            })
            .catch((error) =>
              console.error("Error fetching user profile:", error)
            )
            .finally(() => setLoading(false));
        }
      })
      .catch((error) => {
        console.error("Error fetching visa request:", error);
        setLoading(false);
      });
  }, [visaRequestId]);

  const handleDownloadInvoice = () => {
    const input = document.getElementById("invoice-container");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`invoice_${visaRequest.invoiceNo}.pdf`);
    });
  };

  if (loading)
    return (
      <div id="layout-wrapper">
        <LayoutHeader />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <p>Loading Invoice...</p>
            </div>
          </div>
        </div>
      </div>
    );

  if (!visaRequest || !profile)
    return (
      <div id="layout-wrapper">
        <LayoutHeader />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <p>No data found.</p>
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Visa Invoice</h4>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="card">
                  <div className="card-body">
                    <div
                      id="invoice-container"
                      className="invoice-container"
                      style={{
                        padding: "20px",
                        border: "1px solid #000",
                        maxWidth: "800px",
                        margin: "auto",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#fff",
                        color: "#000",
                      }}
                    >
                      <h2
                        style={{
                          textAlign: "center",
                          borderBottom: "2px solid #000",
                          paddingBottom: "10px",
                        }}
                      >
                        VISA INVOICE
                      </h2>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <div>
                          <p>
                            <strong>From:</strong>
                            <br />
                            Trawtel
                            <br />
                            Uppal, Hyderabad
                            <br />
                            GST No.: XXXXXXXX
                          </p>
                          <p>
                            <strong>To:</strong>
                            <br />
                            {profile.agencyName}
                            <br />
                            GST No.: {profile.gst || "N/A"}
                          </p>
                        </div>

                        <div style={{ textAlign: "right" }}>
                          <p>
                            <strong>Invoice No:</strong> {visaRequest.invoiceNo}
                          </p>
                          <p>
                            <strong>Date:</strong>{" "}
                            {moment().format("DD/MM/YYYY")}
                          </p>
                          <p>
                            <strong>Payment Date:</strong>{" "}
                            {moment(visaRequest.paymentDate).format(
                              "DD/MM/YYYY"
                            )}
                          </p>
                        </div>
                      </div>

                      <hr />

                      <h3 style={{ textAlign: "start" }}>Applicant Details</h3>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: "20px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th
                              style={{
                                border: "1px solid #000",
                                padding: "8px",
                                color: "#000",
                              }}
                            >
                              Applicant Name
                            </th>
                            <th
                              style={{
                                border: "1px solid #000",
                                padding: "8px",
                                color: "#000",
                              }}
                            >
                              Passport No.
                            </th>
                            <th
                              style={{
                                border: "1px solid #000",
                                padding: "8px",
                                color: "#000",
                              }}
                            >
                              Visa Type
                            </th>
                            <th
                              style={{
                                border: "1px solid #000",
                                padding: "8px",
                                color: "#000",
                              }}
                            >
                              Traveler Type
                            </th>
                            <th
                              style={{
                                border: "1px solid #000",
                                padding: "8px",
                                color: "#000",
                              }}
                            >
                              Amount (INR)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {visaRequest.visaApplicants.map(
                            (applicant, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    border: "1px solid #000",
                                    padding: "8px",
                                    color: "#000",
                                  }}
                                >
                                  {applicant.firstName} {applicant.lastName}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #000",
                                    padding: "8px",
                                    color: "#000",
                                  }}
                                >
                                  {applicant.passportNumber}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #000",
                                    padding: "8px",
                                    color: "#000",
                                  }}
                                >
                                  {visaRequest.visaName}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #000",
                                    padding: "8px",
                                    color: "#000",
                                  }}
                                >
                                  {applicant.travelerType}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #000",
                                    padding: "8px",
                                    color: "#000",
                                  }}
                                >
                                  INR{visaRequest.pricePerApplicant}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          maxWidth: "250px",
                          marginLeft: "auto",
                        }}
                      >
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <strong>Subtotal:</strong>{" "}
                          <span>INR{visaRequest.netPrice}</span>
                        </p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <strong>Total Service Fees:</strong>{" "}
                          <span>INR{visaRequest.serviceFee}</span>
                        </p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <strong>Gst (18%):</strong>{" "}
                          <span>INR{visaRequest.tax}</span>
                        </p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            fontWeight: "bold",
                          }}
                        >
                          <strong>Total Amount Paid:</strong>{" "}
                          <span>INR{visaRequest.totalPrice}</span>
                        </p>
                      </div>

                      <h3 style={{ textAlign: "start" }}>Terms & Conditions</h3>
                      <ul>
                        <li>Payment has been received for visa processing.</li>
                        <li>
                          Fees are non-refundable once the application is
                          submitted.
                        </li>
                        <li>
                          Processing time may vary based on embassy
                          requirements.
                        </li>
                      </ul>
                    </div>
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <button
                        onClick={handleDownloadInvoice}
                        className="btn btn-primary"
                        style={{
                          padding: "10px 20px",
                          fontSize: "16px",
                        }}
                      >
                        Download Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
